export default __webpack_public_path__ + "static/media/107-fireplace.a4d64ac6.jpeg";